<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered">
			<div class="portlet-title">
				<div class="caption">
					Edit Location Address
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" novalidate @submit.prevent="modifyLocation($event)">
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<div class="form-body invite-user-form" v-if="process === 'step_1'">
						<google-places-search :passedValue="editingLocation.location_name" :confirmationMessage="confirmationMessage" @selectedLocation="selectedLocationUpdated" :currentSelectedLocation="editingLocation.selected_location"></google-places-search>
					</div>
					<div class="form-body invite-user-form" v-if="process === 'step_2'">
						<google-maps-pin-confirmation :passedValue="editingLocation.selected_location" @updateLocationLatLng="locationLatLngUpdated"></google-maps-pin-confirmation>
					</div>
					<div class="form-actions noborder invite-user-actions">
						<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
						<button type="button" class="btn btn-default" @click="reverseForm()" v-if="process !== 'step_1'">Back</button>
						<button type="button" class="btn blue" @click="advanceForm($event, 'step_2', 'step_1')" v-if="process === 'step_1'" key="create-location-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
						<button type="submit" class="btn blue" v-if="process === 'step_2'" key="create-location-confirm">Submit</button>
					</div>
					<step-counter :steps="steps" :process="process"></step-counter>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import $ from 'jquery'
import GoogleMapsPinConfirmation from '../../../modules/GoogleMapsPinConfirmation'
import GooglePlacesSearch from '../../../modules/GooglePlacesSearch'
import StepCounter from '../../../modules/StepCounter'
import { findIndex } from 'lodash'
import GlobalFunctions from '../../../../global'
import Location from '../../../../controllers/Location'

/**
 * Edit Location Address module is a page for editing the address of a location.
 * @class EditLocationAddress
 * @extends Locations
 * @since 0.0.8
 */

export default {
	name: 'edit-location-address',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			editingLocation: {},
			confirmationMessage: 'Click <b class="font-green-sharp">&#39;Continue&#39;</b> to confirm that this is your location.',
			locationId: 0,
			steps: [{key: 'step_1', name: 'Google Location'}, {key: 'step_2', name: 'Verify Location'}]
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof EditLocationAddress
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === 'My Business Locations - Edit Location Address') {
			this.activePanel = true
			if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
				this.locationId = this.$route.params.location_id
				this.getLocation()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}
	},
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To get details for the current location.
		 * @function
		 * @return {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		getLocation () {
			let _this = this

			Location.getLocation(_this.locationId).then(response => {
				_this.editingLocation = response.payload
			}).catch(reason => {
				if (reason.responseJSON) {
					switch (reason.responseJSON.declaration) {
					case 'location_not_found':
						_this.closePanel()
						break

					default:
						// No default
					}
				}
			})
		},
		/**
		 * To set the selected location to the editingLocation model.
		 * @function
		 * @param {object} val - The selected location being recieved from the Google API.
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		selectedLocationUpdated (val) {
			this.editingLocation.selected_location = val
		},
		/**
		 * To update the map marker coordinates of the selected location.
		 * @function
		 * @param {object} val - The coordinates being recieved from the Google API.
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		locationLatLngUpdated (val) {
			this.editingLocation.selected_location.coordinates = val
		},
		/**
		 * To send the updated details of the location to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		modifyLocation (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			_this.clearError()
			return Location.modifyLocation(_this.editingLocation).then(response => {
				_this.closePanel()
				disabledButton.complete()
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'already_exists':
						_this.errorMessage = 'A location with this name already exists. Please choose a different name.'
						break

					default:
						// No default
					}
				}
				disabledButton.cancel()
			}))
		},
		/**
		 * To clear the object 'editingLocation'.
		 * @function
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		clearForm () {
			this.editingLocation = {}
			$('.invite-user-form').find('input, select').removeClass('edited')
		},
		/**
		 * To close the edit location address panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		closePanel () {
			this.$router.push('/app/my_business/locations')
		},
		/**
		 * To move the form back to the previous step
		 * @function
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			if (index) {
				this.process = this.steps[index - 1].key
			}

			if (this.process !== 'step_1') {
				if ($(document).find('.pac-container').length) {
					$(document).find('.pac-container').remove()
				}
			}

			return
		},
		/**
		 * To move to the next step of the form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {string} step - The step that we are moving to.
		 * @param {string} currentStep - The current step.
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		advanceForm (event, step, currentStep) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return this.validateFormData(currentStep).then(response => {
				_this.clearError()
				disabledButton.complete().then(() => {
					_this.process = step
				})
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_1':
					if (!_this.editingLocation.selected_location || !_this.editingLocation.selected_location.id) {
						reject('You must select a location before continuing.')
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		}
	},
	components: {
		GoogleMapsPinConfirmation,
		GooglePlacesSearch,
		StepCounter
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof EditLocationAddress
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === 'My Business Locations - Edit Location Address') {
				this.activePanel = true
				this.clearError()
				this.clearForm()

				if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
					this.locationId = this.$route.params.location_id
					this.getLocation()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// EditLocationAddress.vue?7acdc37a